import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonLabel,
  IonInput,
  IonPage,
  IonButton,
  IonFooter,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { networkConnectionStatus, newUserState } from "../../data/atoms";
import { ActionType } from "../../models/Enums";
import TopLeftUserName from "../../components/TopLeftUserName";

function Signup() {
  const location = useLocation();
  let history = useHistory();
  const [newUser, setNewUser] = useRecoilState(newUserState);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );
  const [phoneNumber, setPhoneNumber] = useState(newUser?.mobilePhone || "");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    // setPhoneNumber("");
    setErrorMessage("");
  }, [location]);

  const validateInformation = () => {
    const officePhoneRegex =
      /^([0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4,5})$/;

    if (!officePhoneRegex.test(phoneNumber)) {
      setErrorMessage("Invalid mobile phone number");
      return;
    }

    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }

    setNewUser((prevUser) => ({
      ...prevUser,
      mobilePhone: phoneNumber,
    }));

    history.push("/signup-password", {
      actionType: ActionType.ForgotPassword,
    });
  };

  const goBackToEmail = () => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    history.push("/email", {
      actionType: ActionType.NewUser,
    });
  };

  return (
    <IonPage placeholder={undefined}>
      <TopLeftUserName
        headerText="Account Registration"
        actionType={ActionType.ExitUserSetup}
      ></TopLeftUserName>
      <IonContent placeholder={undefined} className="slide-in-right">
        <IonGrid className="container new-signup-page" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="top-inner-sec signup-page-space">
                <h1>Confirm User Information</h1>
                <p>Confirm user information for your account.</p>
              </div>
              <form>
                <div className="field-wrap">
                  <IonLabel className="label" placeholder={undefined}>
                    First Name *
                  </IonLabel>
                  <IonInput
                    disabled={true}
                    className="input-field"
                    type="text"
                    placeholder="First Name"
                    value={newUser.firstName}
                  ></IonInput>
                </div>
                <div className="field-wrap">
                  <IonLabel className="label" placeholder={undefined}>
                    Last Name *
                  </IonLabel>
                  <IonInput
                    disabled={true}
                    className="input-field"
                    type="text"
                    placeholder="Last Name"
                    value={newUser.lastName}
                  ></IonInput>
                </div>
                <div className="field-wrap">
                  <IonLabel className="label" placeholder={undefined}>
                    Email *
                  </IonLabel>
                  <IonInput
                    disabled={true}
                    className="input-field"
                    type="text"
                    placeholder="workemail@email.com"
                    value={newUser.email}
                  ></IonInput>
                </div>
                <div
                  className={`field-wrap ${errorMessage ? "error-wrap" : ""}`}
                >
                  <IonLabel className="label" placeholder={undefined}>
                    Phone Number *
                  </IonLabel>
                  <IonInput
                    className="input-field"
                    type="text"
                    placeholder="Enter Phone number"
                    value={phoneNumber}
                    // onIonChange={(e) => setPhoneNumber(e.detail.value!)}
                    onIonChange={(e: any) => {
                      if (e.target.value.length <= 13) {
                        if (
                          e.target.value.length == 3 &&
                          phoneNumber?.indexOf("-") == -1
                        ) {
                          e.target.value = e.target.value + "-";
                        } else if (
                          e.target.value.length == 7 &&
                          phoneNumber?.lastIndexOf("-") == 3
                        ) {
                          e.target.value = e.target.value + "-";
                        }
                        setPhoneNumber(e.detail.value!);
                      } else {
                        e.target.value = phoneNumber;
                      }
                    }}
                  ></IonInput>
                  {errorMessage && <p className="error-msg">{errorMessage}</p>}
                </div>

                <div className="field-wrap">
                  <IonLabel className="label" placeholder={undefined}>
                    Zip Code *
                  </IonLabel>
                  <IonInput
                    disabled={true}
                    className="input-field"
                    type="text"
                    placeholder="Enter Zip Code"
                    value={newUser.zip}
                  ></IonInput>
                </div>
                <div className="field-wrap">
                  <IonLabel className="label" placeholder={undefined}>
                    Role
                  </IonLabel>
                  <IonInput
                    disabled={true}
                    className="input-field"
                    type="text"
                    placeholder="Role name"
                    value={newUser.clinicianRoleName}
                  ></IonInput>
                </div>
                <div className="field-wrap">
                  <IonLabel className="label" placeholder={undefined}>
                    Workstation *
                  </IonLabel>
                  <IonInput
                    disabled={true}
                    className="input-field"
                    type="text"
                    placeholder="Workstation name"
                    value={newUser.workstationName}
                  ></IonInput>
                </div>
              </form>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
      <IonFooter placeholder={undefined}>
        <div className="container">
          <div className="btn-wrap-sec two-btns signup-btns-wrap">
            <IonButton
              className=" generic-btn-outline"
              placeholder={undefined}
              onClick={() => {
                goBackToEmail();
              }}
            >
              Cancel
            </IonButton>
            <IonButton
              className="generic-btn"
              onClick={() => {
                validateInformation();
              }}
              placeholder={undefined}
            >
              Save
            </IonButton>
          </div>
        </div>
      </IonFooter>
    </IonPage>
  );
}

export default Signup;
